/* eslint-disable array-callback-return */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useActions } from '../../store/hooks/useActions';
import { MainBodyContainer } from '../Equipments/Equipments.styles';
import ProfileHeader from './ProfileHeader';
import Loader from '../../component/Loader/Loader';
import TabsTable from '../../component/Common/Tabs_Table';
import { isEmpty } from '../../shared/utility/isEmpty';
import Toast from '../../component/Common/Toast';
import { apiEndPoints } from '../../services/axios/endPoints';
import { WebService } from '../../services/axios/webServices';
import { sagaCatchBlockHandling } from '../../store/utility/sagaErrorHandling';
import { fetchUserAndLocation } from '../../component/Sidenav/fetchPageStatistics';

const Profile = () => {
  const pageSize = 20;

  const navigate = useNavigate();

  const { userData } = useSelector((state) => state.loginData);
  const { finalMenu } = useSelector((state) => state.home);
  const location = useLocation();
  useEffect(() => {
    const name = finalMenu.find((ele) => ele.path === location.pathname);
    fetchUserAndLocation(location.pathname, userData, {
      pageType: name?.name
    });
  }, []);

  const {
    profileData,
    profileMeta,
    profilePermissions,
    loading,
    error,
    profileCount,
    searchQueries
  } = useSelector((state) => state.profileDetails);

  const {
    getProfileList,
    setSearchQueries,
    getProfileListFailure,
    setToastError
  } = useActions();

  const rowOptions = profilePermissions?.CanEdit
    ? [{ id: 1, label: 'Edit details', value: 'editDetails' }]
    : [];

  const selectionTypeandPosition = {
    isCheckboxTypeSelection: true,
    isSelectionAtFirst: true
  };

  const handlePageChange = (page, rest = {}) => {
    const { searchParams } = rest;
    getProfileList({ page, pageSize, searchParams });
  };

  const setAssetSearchQueries = (searchQueries) => {
    setSearchQueries(searchQueries || {});
  };

  useEffect(() => {
    handlePageChange(1);

    return () => {
      setSearchQueries();
    };
  }, []);

  const clearError = () => {
    getProfileListFailure('');
  };

  const handleProfileCreate = () => {
    WebService.get(`${apiEndPoints.getEquipmentForm}/SpareForm`)
      .then((res) => {
        const { status, data } = res;
        if (status >= 200 && status < 300) {
          const formFilledInput = {};
          data?.map((spare) => {
            if (spare?.defaultValue !== undefined) {
              formFilledInput[spare?.key] = spare?.defaultValue;
            }
          });
          navigate('/home/Stores/Profile/add', {
            state: {
              isFormEditable: true,
              formInput: formFilledInput,
              formApi: `${apiEndPoints.getEquipmentForm}/SpareForm`,
              saveForm: `${apiEndPoints.updateSpare}/new`
            }
          });
        } else {
          throw res.data;
        }
      })
      .catch((e) => {
        const { error } = sagaCatchBlockHandling(e);
        setToastError(error);
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  const handleShowDetails = (ele) => {
    WebService.get(`${apiEndPoints.getProfileSpareDetails}/${ele?.Id}`)
      .then((res) => {
        const { status, data } = res;
        if (status >= 200 && status < 300) {
          navigate('/home/Stores/Profile/details', {
            state: {
              formInput: data,
              isFormEditable: false,
              formApi: `${apiEndPoints.getEquipmentForm}/UpdateSpareForm`,
              saveForm: `${apiEndPoints.updateSpare}/update`
            }
          });
        } else {
          throw res.data;
        }
      })
      .catch((e) => {
        const { error } = sagaCatchBlockHandling(e);
        setToastError(error);
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  const handleRowOptionsItemClick = ({ value }, { activeRowItem }) => {
    if (value === 'editDetails') {
      WebService.get(
        `${apiEndPoints.getProfileSpareDetails}/${activeRowItem?.Id}`
      )
        .then((res) => {
          const { status, data } = res;
          if (status >= 200 && status < 300) {
            navigate('/home/Stores/Profile/edit', {
              state: {
                isFormEditable: true,
                formInput: data,
                formApi: `${apiEndPoints.getEquipmentForm}/UpdateSpareForm`,
                saveForm: `${apiEndPoints.updateSpare}/update`
              }
            });
          } else {
            throw res.data;
          }
        })
        .catch((e) => {
          const { error } = sagaCatchBlockHandling(e);
          setToastError(error);
        })
        .finally(() => {
          // setLoading(false);
        });
    }
  };

  return (
    <>
      <MainBodyContainer>
        <ProfileHeader
          hasBack={false}
          title='Spares'
          isCreate
          canAdd={!!profilePermissions?.CanAdd}
          canEdit={profilePermissions?.CanEdit}
          handleProfileCreate={handleProfileCreate}
          handlePageChange={handlePageChange}
          pageSize={pageSize}
          profileCount={profileCount}
        />
        {loading ? (
          <Loader />
        ) : (
          <TabsTable
            metaDetails={profileMeta}
            dataDetails={profileData}
            showPagiation={false}
            showShortlistSelection={false}
            onItemSelect={handleShowDetails}
            handlePageChange={handlePageChange}
            styleType='strapedTable'
            noItemsFoundMessage='No Spares Found'
            rowOptions={!isEmpty(rowOptions) && rowOptions}
            showRowOptionAtStart={false}
            id='Id'
            handleRowOptionsItemClick={handleRowOptionsItemClick}
            shortListSelectionDetails={selectionTypeandPosition}
            saveSearchQueries={setAssetSearchQueries}
            savedSearchQueries={searchQueries}
            resetSearchQueries={setAssetSearchQueries}
          />
        )}
      </MainBodyContainer>
      {error && (
        <Toast
          header='Error'
          className='fixed right'
          message={error}
          fn={clearError}
        />
      )}
    </>
  );
};

export default Profile;
